import React from 'react';

import { useRespondedYearToDateReportCsv } from 'api';
import { useRespondedYearToDateFilters } from './hooks';
import { MobileReportModal } from '../..';

export const RespondedYearToDateReportMobile: React.FC = () => {
  const filters = useRespondedYearToDateFilters();
  const { mutate: exportCsv } = useRespondedYearToDateReportCsv();

  return <MobileReportModal filters={filters} exportCsv={exportCsv} />;
};
